
      var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCcrIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 44,
  height: 44,
  viewBox: "0 0 44 44",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13 23h10M13 29h10M21.5 6H6.3C5.582 6 5 6.597 5 7.333v29.334C5 37.403 5.582 38 6.3 38h23.4c.345 0 .675-.14.92-.39.243-.25.38-.59.38-.943V18",
  stroke: "#000",
  strokeWidth: 2.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M33.283 5.626c-8.344-.469-12.531 7.27-13.476 11.831-.109.524.503.663.783.207 2.411-3.92 7.524-6.916 12.592-6.086a.524.524 0 0 0 .615-.511l-.053-4.956a.491.491 0 0 0-.461-.485Z",
  fill: "var(--theme-primary, #810ea9)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M40.397 7.527a1 1 0 0 1 0 1.582l-6.68 5.167a1 1 0 0 1-1.612-.791V3.152a1 1 0 0 1 1.612-.791l6.68 5.166Z",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"44\" height=\"44\" viewBox=\"0 0 44 44\" fill=\"none\">\r\n  <path d=\"M13 23H23\" stroke=\"#000000\" stroke-width=\"2.75\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n  <path d=\"M13 29H23\" stroke=\"#000000\" stroke-width=\"2.75\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n  <path d=\"M21.5 6H6.29994C5.582 6 5 6.59695 5 7.33333V36.6667C5 37.403 5.582 38 6.29994 38H29.7001C30.0448 38 30.3755 37.8595 30.6193 37.6095C30.863 37.3594 31 37.0203 31 36.6667V18\" stroke=\"#000000\" stroke-width=\"2.75\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n  <path d=\"M33.283 5.62616C24.9389 5.15726 20.752 12.8956 19.8066 17.4573C19.698 17.9815 20.3099 18.1201 20.5903 17.6641C23.0011 13.7441 28.114 10.7481 33.1822 11.5784C33.5009 11.6306 33.8004 11.3895 33.7969 11.0666L33.7435 6.11147C33.7408 5.85487 33.5392 5.64056 33.283 5.62616Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n  <path d=\"M40.3966 7.52723C40.9143 7.92756 40.9143 8.70896 40.3966 9.10929L33.7166 14.2756C33.0593 14.7839 32.1048 14.3154 32.1048 13.4845L32.1048 3.15199C32.1048 2.32111 33.0593 1.85265 33.7166 2.36096L40.3966 7.52723Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/ccr-icon.f9ebaf5866312352d995b469ca41e738.svg"),
        {
          React: SvgCcrIcon,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      